var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isHide,
            expression: "!isHide"
          }
        ],
        staticClass: "toastr_wrap"
      },
      [
        _c("p", [
          _c("br", { staticClass: "mobile_only" }),
          _vm._v(_vm._s(_vm.$t("MESSAGE.POPUP.RECOMMEND")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap" }, [
          _c(
            "a",
            {
              staticClass: "rdbtn_yes",
              attrs: { href: "javascript:" },
              on: { click: _vm.toastrRecommend }
            },
            [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.YES")))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "rdbtn_no",
              attrs: { href: "javascript:" },
              on: { click: _vm.showBugReportPopup }
            },
            [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.NO")))]
          )
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: { click: _vm.toastrHide }
          },
          [
            _c("span", { staticClass: "sr_only" }, [
              _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61900153", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61900153","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/common/RecommendPopup.vue
// module id = S0Jc
// module chunks = 0